export const APPLY_EXTENDED_FILTERS = 'FILTERS/APPLY_EXTENDED'
export const APPLY_FILTERS = 'FILTERS/APPLY'

export const RESET_EXTENDED_FILTERS = 'FILTERS/RESET_EXTENDED'
export const RESET_FILTERS = 'FILTERS/RESET'

export const SEARCH_SAVE = 'API|SEARCH/SAVE'
export const SEARCH_SAVE_FULFILLED = `FULFILLED_${SEARCH_SAVE}`
export const SEARCH_SAVE_PENDING = `PENDING_${SEARCH_SAVE}`
export const SEARCH_SAVE_REJECTED = `REJECTED_${SEARCH_SAVE}`

export const SEARCH_SAVE_RESET = 'SEARCH/SAVE/RESET'

export const SEARCH_FORM_TOGGLE = 'SEARCH_FORM/TOGGLE'
